<template>
    <div id="tst">
        <v-tooltip bottom>
            <v-chip
                      class="vinculoChip"
                      small
                      color="primary"
                      text-color="white"
                      slot="activator"
                      @click.stop="dialog = true"
                      
                  >
                    CT-e
          </v-chip>
            <span>Visualizar Controle de transporte vinculado a esta nota</span>
        </v-tooltip>  
                   <v-dialog @keydown.esc="dialog = false"
                    v-model="dialog"
                    
                    fullscreen
                    :lazy="true"
                    >

    
                        <v-card>
                            <v-card-title
                            class="headline darkBlue text-xs-center"
                            text-color="white"
                            style="color: white;"
                            primary-title
                            
                            >
                            CT-e Vinculadas
                            <v-spacer></v-spacer>
                            <div id="listaNfe">
                              <span>CT-e Vinculadas</span>
                              <ol v-if="nota.item.cte.length > 0">
                                <li v-for="item in nota.item.cte" :key="item._id" @click="getNFeVinculada(item._id)">
                                  <h6>
                                    {{item.chave}}
                                  </h6>
                                </li>
                              </ol>
                            </div>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click.native="dialog = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                            </v-card-title>

                            <v-card-text id="bodyNFeVinculada">
                              <h2 v-if="nota.item.cte && nota.item.cte.length> 0" class="text-xs-center">{{text_info}}</h2>
                              <h2 v-else class="text-xs-center red--text">Nenhuma CT-e vinculada</h2>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="primary"
                                flat
                                @click="dialog = false"
                            >
                                Fechar
                            </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
    </div>

</template>
<script>
import CteService from "@/domain/notas/cte/CteService";
export default {
  props: ["nota"],
  data() {
    return {
      dialog: false,
      danfeB64: "",
      text_info: "Clique na chave para exibir a nota"
    };
  },
  watch: {
    dialog: function(newV, oldV) {
      if (newV) {
        this.getNFeVinculada(this.nota.item.cte[0]._id);
      }
    }
  },
  computed: {},
  created: function() {},
  methods: {
    getNFeVinculada: async function(id_cte) {
      this.service = new CteService(this.$http);
      await this.service
        .getDacte(id_cte)
        .then(danfe => (this.danfeB64 = danfe));

      this.setPdfData();
    },
    setPdfData: function() {
      if (this.danfeB64) {
        this.text_info = "";
        if (document.getElementById("pdf")) {
          document.getElementById("pdf").remove();
        }
        var embed = document.createElement("EMBED");
        embed.setAttribute(
          "src",
          "data:application/pdf;base64," + encodeURIComponent(this.danfeB64)
        );
        embed.setAttribute("id", "pdf");
        document.querySelector("#bodyNFeVinculada").appendChild(embed);
      } else {
        this.text_info =
          "Nota não encontrada em nosso sistema, disponivel somente em consulta individual no sefaz";
      }
    }
  }
};
</script>
<style>
#tst {
  display: inline-block;
}
#lista {
  padding: 20px;
}
embed {
  width: 100%;
  height: 90vh;
}
#listaNfe ol {
  cursor: pointer;
}
#listaNfe {
  margin-left: -109px;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_vinculo/btnCTeVinculadas/BtnCTeVinculadas.vue